import { defaultText } from '@phaser/helpers/Text';
import { Game } from '@phaser/scenes/Game';

export class AnnounceSystem {
  private _scene: Game = Game.current;

  public announce(message: string) {
    const camera = this._scene.cameras.main;

    const container = this._scene.add.container(camera.displayWidth / 2, camera.displayHeight / 2 - 28)
      .setDepth(1000);

    const topBar = this._scene.add.rectangle(0, 0, 0, 4, 0xFFFFFF);
    const bottomBar = this._scene.add.rectangle(0, 42, 0, 4, 0xFFFFFF);

    const text = this._scene.add.text(0, 20, message, {
      ...defaultText,
      strokeThickness: 0,
    }).setOrigin(0.5);

    container.add([topBar, bottomBar, text]);

    this._scene.tweens.add({
      onUpdate: (tween) => {
        const progress = tween.progress;
        container.alpha = progress < 0.75 ? progress * 1.33 : (1 - progress) * 4;
      },
      targets: container,
      duration: 1500,
      scale: 1,
    });

    this._scene.tweens.add({
      x: text.x - text.width / 2 - 20,
      targets: [topBar, bottomBar],
      width: text.width + 40,
      duration: 750,
    });

    setTimeout(() => container.destroy(), 2000);
  }
}